define('Components/SponsorshipWidget/js/SponsorshipWidget',['hooks',
        'Components/SponsorshipWidget/js/views/SponsorshipWidgetInstanceView',
        'Components/SponsorshipWidget/js/models/SponsorshipWidgetInstanceModel',
    ],
    function (hooks,
              SponsorShipWidgetInstanceView,
              SponsorShipWidgetInstanceModel) {

        return function () {
            hooks.registerWidgetInstance('SponsorshipWidget',
                SponsorShipWidgetInstanceView, SponsorShipWidgetInstanceModel);
        }

    });
